import React from 'react';
import useViewerCommunication from '@components/Chat/ChatMenu/Viewer/useViewerCommunication';

export interface ViewerDataContext
  extends Partial<
    Pick<
      ReturnType<typeof useViewerCommunication>,
      | 'dimensions'
      | 'draftAnnotationData'
      | 'fileAnnotations'
      | 'selectedAnnotationId'
    >
  > {}

export interface ViewerApiContext
  extends Partial<
    Omit<
      ReturnType<typeof useViewerCommunication>,
      | 'dimensions'
      | 'draftAnnotationData'
      | 'fileAnnotations'
      | 'selectedAnnotationId'
    >
  > {}

const viewerDataContext = React.createContext<ViewerDataContext>({});
const viewerApiContext = React.createContext<ViewerApiContext>({});
const { Provider: ViwerDataContextProvider } = viewerDataContext;
const { Provider: ViewerApiContextProvider } = viewerApiContext;

export {
  viewerDataContext,
  viewerApiContext,
  ViwerDataContextProvider,
  ViewerApiContextProvider
};
